import { ArrowForward, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Button, Card, CardContent, CardHeader, Chip, Container, CssBaseline, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link, Outlet, useOutletContext } from 'react-router-dom';
import MyBreadcrumbs from '../../../../components/MyBreadcrumbs';
import MyTable from '../../../../components/MyTable';
import { AuthStore } from '../../../../store/UserStore';
import { base_url } from '../../../../utils/GlobalVariables';
import { CustomDescrypt } from '../../../../utils/MyEncryption';

const Acc = () => {
    const [breadcrumbItem, setBreadcrumbItem] = useState({})

    return (
        <>
            <CssBaseline />
            <MyBreadcrumbs breadcrumbItem={breadcrumbItem} title="SPM Terverifikasi" />
            <Container sx={{ my: 3 }} maxWidth="xxl">
                <Grid container spacing={2} direction="row"
                    justifyContent="center"
                >
                    <Grid item xs={12} md={12}>
                        <Outlet context={{ setBreadcrumbItem }} />
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}

const Data = () => {
    const { setBreadcrumbItem } = useOutletContext();
    const logOut = AuthStore((state) => state.logOut)
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [tableData, setTableData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);

    useEffect(() => {
        setBreadcrumbItem({ '/verif': 'Home', '/verif/terverifikasi_online': 'Terverifikasi Online' })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const columns = [
        {
            field: 'action',
            headerName: '...',
            sortable: false,
            filterable: false,
            hideable: false,
            align: "center",
            headerAlign: 'center',
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <Stack direction="row" spacing={1} justifyContent="center">
                        <Tooltip title="Periksa">
                            <IconButton aria-label="edit" color="info" component={Link} to="periksa-acc" state={params.row}>
                                <ArrowForward />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                );
            }
        },
        {
            field: 'progres',
            headerName: 'Status',
            sortable: false,
            filterable: false,
            hideable: false,
            width: 120,
            align: "center",
            headerAlign: 'center',
            disableColumnMenu: true,
            hide: true,
            renderCell: (params) => {
                let label = "";
                let color = "";

                switch (params.row.progres) {
                    case "0":
                        label = "Baru";
                        color = "primary";
                        break;
                    case "1":
                        label = "Diperbaiki"
                        color = "info";
                        break;
                    case "2":
                        label = "Ditolak";
                        color = "error"
                        break;
                    case "3":
                        label = "Acc";
                        color = "success";
                        break;

                    default:
                        break;
                }

                return (
                    <Chip
                        label={label}
                        color={color}
                        variant="outlined"
                    />
                )
            },
        },
        {
            field: 'updated_at',
            headerName: 'Tanggal Update',
            filterable: false,
            hide: true
        },
        {
            field: 'created_at',
            headerName: 'Tanggal Input',
            filterable: false,
            hide: true
        },
        {
            field: 'no_spm',
            headerName: 'Nomor SPM',
            minWidth: 280,
        },
        { field: 'tgl_spm', headerName: 'Tanggal SPM' },
        {
            field: 'jenis',
            headerName: 'Jenis',
            width: 80,
            renderCell: (params) => {
                return params.row.jenis + " " + params.row.jenis_ls
            }
        },
        { field: 'keperluan', headerName: 'Keperluan', width: 430 },
        {
            field: 'anggaran',
            headerName: 'Anggaran',
            width: 150,
            renderCell: (params) => {
                return new Intl.NumberFormat("id-ID", {
                    style: "currency",
                    currency: "IDR",
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                }).format(params.row.anggaran);
            }
        },
        { field: 'no_spp', headerName: 'Nomor SPP', width: 100, hide: true },
        {
            field: 'nm_opd',
            headerName: 'OPD',
            minWidth: 200,
            // type: "boolean"
        },
        {
            field: 'id_opd',
            headerName: 'ID OPD',
            hide: true
        }
    ];

    const requestData = () => {
        setTableLoading(true)
        axios.get(
            base_url + '/verif/pencairan/getAcc',
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`
                }
            })
            .then((response) => {
                const data = response.data;
                setTableData(data.pencairan)
                setTableLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
            })
    }

    useEffect(() => {
        requestData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        // <Card>
        //     <CardHeader
        //         title="SPM Terverifikasi"
        //     />
        //     <CardContent>
                <MyTable
                    rows={tableData}
                    columns={columns}
                    row_id={(row) => row.no_spm}
                    isLoading={tableLoading}
                />
                // {/* jhjkhzxcjk */}
        //     {/* </CardContent>
        // </Card> */}
    )
}

export default Acc
export { Data as DataAcc }